import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import {defineCustomElement as uilabIconDCE } from '@uilab/icon/components/uilab-icon';
import {defineCustomElement as uilabIconGetDefDCE } from '@uilab/icon/components/uilab-icon-get-def';

uilabIconDCE();
uilabIconGetDefDCE();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
